// 認証不要
import { NextPage } from 'next';
import React, { useEffect } from 'react';

import SignUpPage from '~/feature/sign-up/Page/MobilePage';
import { currentUser } from '~/firebase/fbAuth';
import withSigned from '~/shared/components/shared/withSigned';
import { LoggingLabel } from '~/utils/constants';
import { logger } from '~/utils/loggerUtil';
import { sendSimpleLog } from '~/utils/logging';
import { getClientId } from '~/utils/measurementUtils';

const SignUp: NextPage = () => {
  // ログインページが表示されたイベントを送る
  useEffect(() => {
    sendSimpleLog(
      LoggingLabel.DID_MOUNT_SIGN_UP_PAGE,
      'v1',
      '',
      currentUser?.uid || undefined,
      {
        clientId: getClientId(),
      }
    ).catch(e => logger.error(e));
  }, []);

  return <SignUpPage />;
};

export default withSigned(SignUp);
